<template>
  <div class="vld-overlay is-active is-full-page vld-background" z-index="0">
    <b-spinner class="m-5" variant="primary" label="Cargando..."></b-spinner>
  </div>
</template>

<script>
import {BSpinner} from 'bootstrap-vue';
import Vue from 'vue';
Vue.component('b-spinner', BSpinner);

export default {

}
</script>

<style>
.vld-background{
  background-color: rgba(255, 255, 255, .90);
}
</style>